export default {
  config: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/layouts/config.vue").then(m => m.default || m),
  default: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/layouts/default.vue").then(m => m.default || m),
  diy: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/layouts/diy.vue").then(m => m.default || m),
  reservation: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/layouts/reservation.vue").then(m => m.default || m)
}